import { useDroppable } from "@dnd-kit/core";
import React from "react";

export default function DroppableWrapper({ id, data, children, style }) {
  const { isOver, setNodeRef } = useDroppable({
    id,
    data, // ✅ folder data
  });

  return (
    <div
      className="no-select"
      ref={setNodeRef}
      style={{
        background: isOver ? "rgba(0,123,255,0.12)" : "inherit",
        border: isOver ? "3px dashed #1890ff" : "none",
        borderRadius: "8px",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
